<template>
  <div
    class="custom-message-component-expanded"
    @click="clickHandle"
  >
    <slot />
  </div>
</template>

<script lang="ts" >
import { pushUrl } from '@/business/chat/custom-message-util';
import {
  CustomMessageMayItem,
} from '_c/typings/model/chat/text-node';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'CustomMessageExpanded',
  props: {
    attr: {
      type: Object as PropType<CustomMessageMayItem>,
      required: true,
    },
  },

  setup(props) {
    function clickHandle(e: Event): void {
      if (props.attr.onClick) {
        e.stopPropagation();
        pushUrl(props.attr.onClick, props.attr.reportData);
      }
    }
    return {
      clickHandle,
    };
  },
});

</script>

<style scoped lang="scss">
.custom-message-component-expanded {
  flex: 1;
}
</style>
